import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { ITemplatesStore, IThunkGetMoreTemplates } from '../types';

const onGetMoreTemplates: IThunkGetMoreTemplates = thunk(
  // @ts-ignore
  async ({ setMoreTemplates }, filters, { getState }) => {
    const localState = getState() as ITemplatesStore;

    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.templates.getList({
      ...filters,
      ...paginationPayload,
    });

    setMoreTemplates(data);
  },
);

export default onGetMoreTemplates;
